export var getMVTFeaturesInExtent = function getMVTFeaturesInExtent(source, extent) {
  var idPropName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
  var featuresById = new Map();
  var features = source.getFeaturesInExtent(extent);
  // map will only hold one feature/id so we get rid of duplicates
  features.forEach(function (feature) {
    var id = feature.get(idPropName);
    if (typeof id !== 'undefined') {
      featuresById.set(id, feature);
    }
  });
  return Array.from(featuresById.values());
};